import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import {
  ClickAwayListener,
  FormControl,
  Grow,
  Link,
  MenuItem,
  Paper,
  Popper,
} from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import CloudArrowDownIcon16pxSvg from "../../../assets/images/icons/CloudArrowDownIcon16pxSvg";
import CloudArrowUpIcon16pxSvg from "../../../assets/images/icons/CloudArrowUpIcon16pxSvg";
import CustomSelect from "../../../components/CustomSelect";
import { CustomAdvancedMenuList } from "../../../components/StyledComponents";
import { useSettings } from "../../../context/SettingsContext";
import { formatDateString } from "../../../utils/FormatDateTimeString/dateUtils";
import { USER_GROUP } from "./../../../assets/data/UserGroupsData";
import CustomAutocomplete from "./../../../components/CustomAutocomplete";
import PrimaryDivider from "./../../../components/PrimaryDivider";
import {
  ControlpanelErrorButton,
  ControlpanelPrimaryButton,
  ControlpanelSuccess3thButton,
  ControlpanelSuccessButton,
  ControlpanelWarning2thButton,
} from "./../../../components/StyledButton";
import AddHolidayDialog from "./AddHolidayDialog";
import AddLeaveDialog from "./AddLeaveDialog";
import ConfigureLeaveTypesDialog from "./ConfigureLeaveTypesDialog";
import EditLeaveDialog from "./EditLeaveDialog";
import LeaveAndHolidaysMonthEventsCalendar from "./LeaveAndHolidaysMonthEventsCalendar";
import SelectDataToExportLeaveAndHolidayDialog from "./SelectDataToExportLeaveAndHolidayDialog";
import SelectDataToImportLeaveAndHolidayDialog from "./SelectDataToImportLeaveAndHolidayDialog";
import { useAuth } from "../../../context/AuthContext";
import { vi, enUS } from "date-fns/locale";
import AddLeaveRequestDialog from "./AddLeaveRequestDialog";
import DetailRequestDialog from "./DetailRequestDialog";
import LeaveApi from "../../../axios/LeaveAndHoliday/LeaveApi";
import { toast } from "react-toastify";
import DeleteLeaveDialog from "./DeleteLeaveDialog";
import PencilEditIcon16pxSvg from "../../../assets/images/icons/PencilEditIcon16pxSvg";
import InfoIcon from "@mui/icons-material/Info";
import DeleteHolidayDialog from "./DeleteHolidayDialog";
import DetailRequestDialogAR from "./DetailRequestDialogAR";
import EditHolidayDialog from "./EditHolidayDialog";
import { getListUserGroup } from "../../../axios/Group/GroupUrlApi";
import { useLoading } from "../../../context/LoadingContext";
import { useSearchParams } from "react-router-dom";
import { startOfDay } from "date-fns";
import DefaultTooltip from "../../../components/DefaultTooltip";
import QuestionIcon16pxSvgWhite from "../../../assets/images/icons/QuestionIcon16pxSvgWhite";
import { getShiftListAll } from "../../../axios/Shift/ShiftApi";
import { useNotification } from "../../../context/NotificationContext";
import { updateNotification } from "../../../axios/Notification/NotificationApi";

const LeaveAndHolidayInfo = forwardRef((props, ref) => {
  const {
    genaralSettingDateFormat,
    isAdmin,
    profile,
    genaralSettingTimeZone,
    isEmployee
  } = useAuth();
  const { t, i18n } = useTranslation();
  const {
    tabValue,
    setSelectedDate,
    onRefresh,
    refreshData,
    selectedDate,
    leaveInfo,
    holidayInfo,
    setLoading,
    calculateDisplayedWeeks,
    userData,
    groupData,
    handleGetDataFilterLeave,
    leaveTypesData,
    handleGetStatusShowRejectData,
    formatLeaveFilter,
    dialogOnly = false,
    setTabValue,
  } = props;
  // const userData = UserData();
  const { settings } = useSettings();
  const currentLang = i18n.language;
  const [show, hide] = useLoading();
  const [shiftsData, setShiftsData] = useState([]);

  useEffect(() => {
    const fetchShift = async () => {
      try {
        show();
        const response = await getShiftListAll(
          localStorage.getItem("i18nextLngId")
        );
        const shiftList = response.data.listShift;
        // const modifiedShiftsList = [...shiftList, { shiftId: 0, shiftName: 'All shift' }];
        setShiftsData(shiftList);
      } catch (error) {
        if (error.response) {
          toast.error(t(error?.response.data));
        }
        else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        hide();
      }
    };


    fetchShift();
  }, [hide, show, t]);

  const { getLeaveRequestId, getPoliciesList } = LeaveApi();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedLeaveForDialog, setSelectedLeaveForDialog] = useState(null);
  const [dialogIsRequestMode, setDialogIsRequestMode] = useState(false);
  const fetchedLeaveIdRef = useRef(null);

  const [showRejectedLeaves, setShowRejectedLeaves] = useState(false);
  const [openAdvancedLeaveAndHoliday, setOpenAdvancedLeaveAndHoliday] =
    useState(false);
  const anchorRefAdvancedLeaveAndHoliday = useRef(null);
  const dateTimeFormat = genaralSettingDateFormat + " HH:mm";
  const [selectNewGroup, setSelectedNewGroup] = useState(1);
  const [userGroup, setUserGroup] = useState([]);

  const statusLeaveData = [
    {
      statusLeaveId: 0,
      statusName: t("common.all-status"),
    },
    {
      statusLeaveId: 1,
      statusName: t("common.approved"),
    },
    {
      statusLeaveId: 2,
      statusName: t("common.rejected"),
    },
    {
      statusLeaveId: 3,
      statusName: t("common.requested"),
    },
  ];

  const clearLeaveIdFromUrl = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("leaveId");
    setSearchParams(params);
  };

  const handleToggleAdvancedLeaveAndHoliday = () => {
    setOpenAdvancedLeaveAndHoliday(!openAdvancedLeaveAndHoliday);
  };

  const handleCloseAdvancedLeaveAndHoliday = (event) => {
    if (
      anchorRefAdvancedLeaveAndHoliday.current &&
      anchorRefAdvancedLeaveAndHoliday.current.contains(event.target)
    ) {
      return;
    }
    setOpenAdvancedLeaveAndHoliday(false);
  };

  const [openSelectDataToImport, setOpenSelectDataToImport] = useState(false);

  const handleOpenSelectDataToImport = () => {
    setOpenSelectDataToImport(true);
  };

  const handleCloseSelectDataToImport = () => {
    setOpenSelectDataToImport(false);
  };

  const [openSelectDataToExport, setOpenSelectDataToExport] = useState(false);

  const handleOpenSelectDataToExport = () => {
    setOpenSelectDataToExport(true);
  };

  const handleCloseSelectDataToExport = () => {
    setOpenSelectDataToExport(false);
  };

  const [openConfigureLeaveTypes, setOpenConfigureLeaveTypes] = useState(false);

  const handleOpenConfigureLeaveTypes = () => {
    setOpenConfigureLeaveTypes(true);
  };

  const handleCloseConfigureLeaveTypes = () => {
    setOpenConfigureLeaveTypes(false);
  };

  const [openAddLeave, setOpenAddLeave] = useState(false);

  const handleOpenAddLeave = () => {
    setOpenAddLeave(true);
  };

  const handleCloseAddLeave = () => {
    setOpenAddLeave(false);
  };

  const [openDeleteLeave, setOpenDeleteLeave] = useState(false);
  const handleOpenDeleteLeave = () => {
    setOpenDeleteLeave(true);
  };

  const handleCloseDeleteLeave = () => {
    setOpenDeleteLeave(false);
  };

  const [openDeleteHoliday, setOpenDeleteHoliday] = useState(false);
  const handleOpenDeleteHoliday = () => {
    setOpenDeleteHoliday(true);
  };

  const handleCloseDeleteHoliday = () => {
    setOpenDeleteHoliday(false);
  };

  const [openEditHoliday, setOpenEditHoliday] = useState(false);
  const handleOpenEditHoliday = () => {
    setOpenEditHoliday(true);
  };

  const handleCloseEditHoliday = () => {
    setOpenEditHoliday(false);
  };

  const [openAddLeaveRequest, setOpenAddLeaveRequest] = useState(false);
  const handleOpenAddLeaveRequest = () => {
    setOpenAddLeaveRequest(true);
  };

  const handleCloseAddLeaveRequest = () => {
    setOpenAddLeaveRequest(false);
  };

  const [openEditLeave, setOpenEditLeave] = useState(false);

  const handleOpenEditLeave = () => {
    setOpenEditLeave(true);
  };

  const handleCloseEditLeave = () => {
    setOpenEditLeave(false);
  };

  const [openApproveLeave, setOpenApproveLeave] = useState(false);
  const [openApproveLeaveAR, setOpenApproveLeaveAR] = useState(false);

  const handleOpenApproveLeave = () => {
    setSelectedLeaveForDialog(leaveInfo);  // ✅ dùng leaveInfo từ props
    setDialogIsRequestMode(false);
    setOpenApproveLeave(true);
  };

  const handleCloseApproveLeave = () => {
    setOpenApproveLeave(false);
    setSelectedLeaveForDialog(null);
    setDialogIsRequestMode(false);
    fetchedLeaveIdRef.current = null;

    // nếu URL đang có leaveId thì xóa đi
    const params = new URLSearchParams(searchParams);
    params.delete("leaveId");
    setSearchParams(params);
  };

  const handleOpenApproveLeaveAR = () => {
    setSelectedLeaveForDialog(leaveInfo);  // ✅
    setDialogIsRequestMode(false);
    setOpenApproveLeaveAR(true);
  };

  const handleCloseApproveLeaveAR = () => {
    setOpenApproveLeaveAR(false);
    setSelectedLeaveForDialog(null);
    setDialogIsRequestMode(false);
    fetchedLeaveIdRef.current = null;

    const params = new URLSearchParams(searchParams);
    params.delete("leaveId");
    setSearchParams(params);
  };

  const leaveIdParam = searchParams.get("leaveId");

  useEffect(() => {
    // Hết leaveId trên URL → cho phép mở lại cùng id lần sau
    if (!leaveIdParam) {
      fetchedLeaveIdRef.current = null;
      return;
    }
    if (fetchedLeaveIdRef.current === leaveIdParam) return;
    fetchedLeaveIdRef.current = leaveIdParam;

    // Mở từ notification → nhảy sang tab request
    setTabValue?.(1);

    let cancelled = false;

    const fetchById = async () => {
      try {
        show();

        const res = await getLeaveRequestId({
          leaveRequestId: Number(leaveIdParam),
          langId: localStorage.getItem("i18nextLngId"),
        });
        if (cancelled) return;

        const data = res?.data?.data?.[0];

        if (!data) {
          toast.error(
            t("common.error-get-leave-detail") ||
            "Không lấy được chi tiết đơn nghỉ phép"
          );
          fetchedLeaveIdRef.current = null;
          return;
        }

        const requestStatusId = Number(data.requestStatusId ?? data.approvalStatusId);
        setSelectedLeaveForDialog({
          ...data,
          leaveRequestId: data.leaveRequestId ?? data.id ?? Number(leaveIdParam),
          leaveId: data.leaveId ?? data.leaveRequestId ?? data.id ?? Number(leaveIdParam),
          name: data.fullName || data.name,
          approvalStatusId: requestStatusId,
          requestStatusId,
        });
        setDialogIsRequestMode(true);

        // Request API: 1 = pending → dialog duyệt; còn lại → dialog xem chi tiết
        if (requestStatusId === 1) {
          setOpenApproveLeaveAR(false);
          setOpenApproveLeave(true);
        } else {
          setOpenApproveLeave(false);
          setOpenApproveLeaveAR(true);
        }
      } catch (err) {
        if (cancelled) return;
        toast.error(
          t("common.error-get-leave-detail") ||
          "Không lấy được chi tiết đơn nghỉ phép"
        );
        fetchedLeaveIdRef.current = null;
        clearLeaveIdFromUrl();
      } finally {
        if (!cancelled) hide();
      }
    };

    fetchById();
    return () => {
      cancelled = true;
    };
  }, [leaveIdParam]);

  const [openAddHoliday, setOpenAddHoliday] = useState(false);

  const handleOpenAddHoliday = () => {
    setOpenAddHoliday(true);
  };

  const handleCloseAddHoliday = () => {
    setOpenAddHoliday(false);
  };

  const [formData, setFormData] = useState({
    group: groupData[0]?.id ? groupData[0]?.id : 1,
    selecStatusLeave: 0,
    userId: "",
  });

  const [selectedUser, setSelectedUser] = useState(null); // lưu user object
  const [selectedGroup, setSelectedGroup] = useState(formData.group || null); // lưu group id

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "group") {
      setSelectedGroup(value); // ✅ lưu groupId
      setSelectedNewGroup?.(value);
    }
  };

  const handleDataChange = (name, newData) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newData,
    }));

    if (name === "userId") {
      setSelectedUser(newData); // ✅ lưu user object
    }
  };

  //handleGetDataFilterLeave
  useEffect(() => {
    handleGetDataFilterLeave?.(formData);
  }, [formData]);

  useEffect(() => {
    handleGetStatusShowRejectData?.(showRejectedLeaves);
  }, [showRejectedLeaves]);

  const parseNumOfDay = (value) => {
    if (!value) return 0;

    // Tách các phần có thể có
    const parts = value.split(" ");
    let days = 0;
    let timeStr = "";

    if (parts.length === 3) {
      // Trường hợp: "6 Day 23:59:00"
      days = parseInt(parts[0], 10);
      timeStr = parts[2];
    } else if (parts.length === 2 && parts[1].includes(":")) {
      // Trường hợp: "6 23:59:00"
      days = parseInt(parts[0], 10);
      timeStr = parts[1];
    } else if (parts.length === 1 && parts[0].includes(":")) {
      // Trường hợp: "23:59:00" (không có day)
      timeStr = parts[0];
    } else if (!isNaN(parts[0])) {
      // Trường hợp: "6"
      days = parseInt(parts[0], 10);
    }

    // Nếu không có thời gian thì trả về nguyên số ngày
    if (!timeStr) return days;

    // Tính tổng giờ
    const [h, m, s] = timeStr.split(":").map(Number);
    const totalHours = h + m / 60 + s / 3600;

    // Logic cộng thêm
    if (totalHours > 8) return days + 1;
    if (totalHours > 3.5 && totalHours < 8) return days + 0.5;

    // Nếu chỉ có giờ (và day = 0) nhưng nhỏ hơn 4h, vẫn coi là 1 ngày
    if (days === 0 && totalHours > 0 && totalHours < 24) {
      return totalHours;
    }

    return days;
  };

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        group: selectNewGroup,
        pageNo: 1,
        recordPerPage: 50000,
        langId: localStorage.getItem("i18nextLngId")
      }
      show()
      try {
        const response = await getListUserGroup(payload);
        setUserGroup(response.data.data)

      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        hide()
      }
    };
    fetchData();

  }, [selectNewGroup, t, refreshData]);

  const [policiesList, setPoliciesList] = useState([]);

  useEffect(() => {
      const fetchDataPolicies = async () => {
        show();
        try {
          const payload = {
            status: true
          };
          const response = await getPoliciesList(payload);
          if (
            response.data.message === "Successful" ||
            response.data.message === "Thành công"
          ) {
            setPoliciesList(response.data.data);
            hide();
          }
        } catch (error) {
          hide();
          toast.error(error.response.data.message);
        } finally {
          hide();
        }
      };
  
      fetchDataPolicies();
    }, []);
  
  const { notifications } = useNotification();

  const markNotificationRead = async (requestId) => {
      try {
  
        const role = isAdmin ? "ADMIN" : "USER";
  
        const updated = notifications.map(n =>
          n.id === requestId ? { ...n, unread: false } : n
        );
  
        await updateNotification(updated, profile.userId, role, profile.companyId);
        onRefresh();
  
      } catch (e) {
        console.error(e);
      }
    };

  const [selectedHolidayForDialog, setSelectedHolidayForDialog] = useState({});

  useImperativeHandle(ref, () => ({
    openConfigureLeaveTypes: handleOpenConfigureLeaveTypes,
    openAddLeave: handleOpenAddLeave,
    openAddHoliday: handleOpenAddHoliday,
    openAddLeaveRequest: handleOpenAddLeaveRequest,
    openSelectDataToImport: handleOpenSelectDataToImport,
    openSelectDataToExport: handleOpenSelectDataToExport,
    openDeleteHoliday: (info) => {
      setSelectedHolidayForDialog(info);
      setOpenDeleteHoliday(true);
    },
    openEditHoliday: (info) => {
      setSelectedHolidayForDialog(info);
      setOpenEditHoliday(true);
    },
  }));

  const activeHolidayInfo = dialogOnly
    ? (Object.keys(selectedHolidayForDialog).length ? selectedHolidayForDialog : holidayInfo)
    : holidayInfo;

  const renderDialogs = () => (
    <>
      <SelectDataToImportLeaveAndHolidayDialog
        open={openSelectDataToImport}
        handleClose={handleCloseSelectDataToImport}
        idFilePassword="selectDataToExportLeaveAndHolidayFilePasswordInfo"
      />
      <SelectDataToExportLeaveAndHolidayDialog
        open={openSelectDataToExport}
        handleClose={handleCloseSelectDataToExport}
      />
      <ConfigureLeaveTypesDialog
        open={openConfigureLeaveTypes}
        handleClose={handleCloseConfigureLeaveTypes}
        dateTimeFormat={dateTimeFormat}
        genaralSettingDateFormat={genaralSettingDateFormat}
        onRefresh={onRefresh}
      />
      <AddLeaveDialog
        open={openAddLeave}
        handleClose={handleCloseAddLeave}
        setLoading={setLoading}
        onRefresh={onRefresh}
        selectedDate={selectedDate}
        dateTimeFormat={dateTimeFormat}
        userData={userData}
        leaveTypesData={leaveTypesData}
        shiftsData={shiftsData}
        policiesList={policiesList}
        setTabValue={setTabValue}
      />
      <AddHolidayDialog
        open={openAddHoliday}
        handleClose={handleCloseAddHoliday}
        setLoading={setLoading}
        onRefresh={onRefresh}
        selectedDate={selectedDate}
        dateTimeFormat={dateTimeFormat}
      />
      <AddLeaveRequestDialog
        open={openAddLeaveRequest}
        handleClose={handleCloseAddLeaveRequest}
        setLoading={setLoading}
        onRefresh={onRefresh}
        selectedDate={selectedDate}
        dateTimeFormat={dateTimeFormat}
        leaveTypesData={leaveTypesData}
        genaralSettingTimeZone={genaralSettingTimeZone}
        shiftsData={shiftsData}
      />
      {openApproveLeave && (
        <DetailRequestDialog
          onClose={handleCloseApproveLeave}
          leaveInfo={selectedLeaveForDialog}
          onRefresh={onRefresh}
          leaveTypesData={leaveTypesData}
          policiesList={policiesList}
          isRequestMode={dialogIsRequestMode}
        />
      )}
      {openApproveLeaveAR && (
        <DetailRequestDialogAR
          onClose={handleCloseApproveLeaveAR}
          leaveInfo={selectedLeaveForDialog}
          onRefresh={onRefresh}
          leaveTypesData={leaveTypesData}
          isRequestMode={dialogIsRequestMode}
        />
      )}
      {openDeleteLeave && (
        <DeleteLeaveDialog
          onClose={handleCloseDeleteLeave}
          onRefresh={onRefresh}
          leaveInfo={leaveInfo}
        />
      )}
      {openEditLeave && (
        <EditLeaveDialog
          open={openEditLeave}
          onClose={handleCloseEditLeave}
          leaveInfo={leaveInfo}
          onRefresh={onRefresh}
          leaveTypesData={leaveTypesData}
          shiftsData={shiftsData}
          selectedDate={selectedDate}
        />
      )}
      {openDeleteHoliday && (
        <DeleteHolidayDialog
          holidayInfo={activeHolidayInfo}
          onRefresh={onRefresh}
          onClose={handleCloseDeleteHoliday}
        />
      )}
      <EditHolidayDialog
        open={openEditHoliday}
        handleClose={handleCloseEditHoliday}
        setLoading={setLoading}
        onRefresh={onRefresh}
        selectedHoliday={activeHolidayInfo}
        dateTimeFormat={dateTimeFormat}
      />
    </>
  );

  if (dialogOnly) {
    return renderDialogs();
  }

  return (
    <div className="leave-and-holiday-info">
      <div className="flex justify-between">
        <div className="flex gap-3">
          {tabValue === 0 && isEmployee && (
            // <ControlpanelSuccess3thButton onClick={handleOpenAddLeaveRequest}>
            //   <AddIcon />
            //   <p>{t("common.add-leave-request")}</p>
            // </ControlpanelSuccess3thButton>

            <ControlpanelPrimaryButton onClick={handleOpenAddLeaveRequest}>
              <AddIcon />
              <p className="mr-1">{t("common.add-leave-request")}</p>
              <div className="hidden md:block">
                <DefaultTooltip
                  title={t('tool-tip.add-leave-request')}
                  readMore={true}
                  content={
                    <div className="flex flex-col gap-3">
                      <p>{t('tool-tip.add-leave-request-des')}</p>
                    </div>
                  }
                >
                  <QuestionIcon16pxSvgWhite />
                </DefaultTooltip>
              </div>


            </ControlpanelPrimaryButton>
          )}
          {isAdmin && tabValue === 0 && (
            <>
              {/* <ControlpanelSuccess3thButton onClick={handleOpenAddLeave}>
                <AddIcon />
                <p>{t("button.add-leave")}</p>
              </ControlpanelSuccess3thButton> */}
              <ControlpanelPrimaryButton onClick={handleOpenAddLeave}>
                <AddIcon />
                <p className="mr-1">{t("button.add-leave")}</p>
                <div className="hidden md:block"><DefaultTooltip
                  title={t('tool-tip.add-leave')}
                  readMore={true}
                  content={
                    <div className="flex flex-col gap-3">
                      <p>{t('tool-tip.add-leave-des')}</p>
                    </div>
                  }
                >
                  <QuestionIcon16pxSvgWhite />
                </DefaultTooltip></div>
              </ControlpanelPrimaryButton>
            </>
          )}
          {isAdmin && tabValue === 1 && (
            <>
              <ControlpanelWarning2thButton onClick={handleOpenAddHoliday}>
                <AddIcon />
                <p className="">{t("button.add-holiday")}</p>

              </ControlpanelWarning2thButton>
            </>
          )}
        </div>
        {isAdmin && (
          <div>
            <ControlpanelPrimaryButton
              disableRipple
              onClick={handleToggleAdvancedLeaveAndHoliday}
              ref={anchorRefAdvancedLeaveAndHoliday}
              id="advanced-leave-and-holiday-button"
              aria-controls={
                openAdvancedLeaveAndHoliday
                  ? "advanced-leave-and-holiday-menu"
                  : undefined
              }
              aria-expanded={openAdvancedLeaveAndHoliday ? "true" : undefined}
              aria-haspopup="true"
            >
              <SettingsIcon />
              <ArrowDropDownIcon className="!text-[20px]" />
            </ControlpanelPrimaryButton>
            <div>
              <Popper
                open={openAdvancedLeaveAndHoliday}
                anchorEl={anchorRefAdvancedLeaveAndHoliday.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                className="z-10"
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "left top" : "left bottom",
                    }}
                  >
                    <Paper style={{ borderRadius: "8px", }}>
                      <ClickAwayListener
                        onClickAway={handleCloseAdvancedLeaveAndHoliday}
                      >
                        <CustomAdvancedMenuList
                          id="advanced-leave-and-holiday-menu"
                          aria-labelledby="advanced-leave-and-holiday-button"
                        >
                          <MenuItem
                            style={{
                              borderBottom: "1px solid #E5E7EB",
                              // opacity: "0.5",
                              pointerEvents: "auto",
                            }}
                            onClick={(e) => {
                              handleOpenConfigureLeaveTypes();
                              handleCloseAdvancedLeaveAndHoliday(e);
                            }}
                          >
                            <Link>
                              <SettingsSuggestIcon className="!text-[20px]" />
                              <p>{t("button.configure-leave-types")}</p>
                            </Link>
                          </MenuItem>
                          <MenuItem
                            style={{
                              borderBottom: "1px solid #E5E7EB",
                              opacity: "0.5",
                              pointerEvents: "none",
                            }}
                            onClick={(e) => {
                              handleOpenSelectDataToImport();
                              handleCloseAdvancedLeaveAndHoliday(e);
                            }}
                          >
                            <Link>
                              <CloudArrowUpIcon16pxSvg />
                              <p>{t("button.import-data")}</p>
                            </Link>
                          </MenuItem>
                          <MenuItem
                            style={{ opacity: "0.5", pointerEvents: "none" }}
                            onClick={(e) => {
                              handleOpenSelectDataToExport();
                              handleCloseAdvancedLeaveAndHoliday(e);
                            }}
                          >
                            <Link>
                              <CloudArrowDownIcon16pxSvg />
                              <p>{t("button.export-data")}</p>
                            </Link>
                          </MenuItem>
                        </CustomAdvancedMenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          </div>
        )}
      </div>
      <div className="my-3">
        <PrimaryDivider />
      </div>
      {tabValue === 0 && (
        <div className="select-group mb-3">
          <div className="flex flex-col md:items-center md:justify-between gap-3 md:flex-row">
            <p>{t("common.select-status")}</p>
            <div className="min-w-[300px]">
              <FormControl className="w-full">
                <CustomSelect
                  name="selecStatusLeave"
                  id="selecStatusLeave"
                  value={formData.selecStatusLeave}
                  onChange={handleInputChange}
                  options={statusLeaveData}
                  dataType="selecStatusLeave"
                />
              </FormControl>
            </div>
          </div>
        </div>
      )}
      {tabValue === 0 && isAdmin && (
        <div className="select-group">
          <div className="flex flex-col md:items-center md:justify-between gap-3 md:flex-row">
            <p>{t("common.select-user-group")}</p>
            <div className="min-w-[300px]">
              <FormControl className="w-full">
                <CustomSelect
                  name="group"
                  id="group"
                  value={formData.group}
                  onChange={handleInputChange}
                  options={groupData}
                  dataType="group"
                />
              </FormControl>
            </div>
          </div>
          <div className="flex flex-col md:items-center md:justify-between gap-3 md:flex-row mt-3">
            <p>{t("common.select-user")}</p>
            <div className="min-w-[300px]">
              <CustomAutocomplete
                options={userGroup}
                name="userId"
                id="selectUser"
                freeSolo={true}
                placeholder={t("common.content-161")}
                dataType="user"
                onDataChange={handleDataChange}
              // disabledValues={selectedValues}
              />
            </div>
          </div>
          {/* <div className='mt-3 flex gap-3 items-center'>
                  <Checkbox
                     id='rejectedLeaves'
                     className='!p-0 !ml-[-3px]'
                     checked={showRejectedLeaves}
                     onChange={() => setShowRejectedLeaves(!showRejectedLeaves)}
                  />
                  <p>{t('common.show-rejected-leaves')}</p>
               </div> */}
        </div>
      )}

      <div className="p-3 shadow-primary mt-3 rounded-md flex justify-between items-center">
        <div className="flex flex-col gap-1">
          {/* <>
                  <p className='text-base font-semibold'>
                     {format(displayDate, myDate ? 'dd/MM/yyyy' : settings.dateFormat)}
                  </p>
                  <p className='opacity-70'>
                     {format(displayDate, 'EEEE')}
                  </p>
               </> */}

          <p className="text-base font-semibold">
            {formatDateString(
              selectedDate,
              genaralSettingDateFormat || settings.dateFormat
            )}
          </p>
          <p className="opacity-70">
            {format(selectedDate, "EEEE", {
              locale: currentLang === "vi" ? vi : enUS,
            })}
          </p>
        </div>
        <div>
          <ControlpanelSuccess3thButton
            onClick={() => setSelectedDate(startOfDay(new Date()))}
          >
            {t("button.select-today")}
          </ControlpanelSuccess3thButton>
        </div>
      </div>
      {tabValue === 0 && Object.keys(leaveInfo).length > 0 && (
        <div className="leaves-info p-3 shadow-primary mt-3 rounded-md flex flex-col gap-3">
          <div className="flex justify-between">
            <div className="flex flex-col gap-1">
              <p className="text-base font-semibold">{leaveInfo.name}</p>
              <div className="flex items-center gap-2">
                <p className="opacity-70">
                  {
                    leaveInfo.requestStartDate
                  }{" "}
                  -{" "}
                  {
                    leaveInfo.requestEndDate

                  }
                </p>
                {/* <div className="bg-[#3B82F6] rounded-md p-2">
                  <p className="text-white">
                    {leaveInfo.numOfDay}{" "}
                    {t("common.day").toLowerCase()}
                  </p>
                </div> */}
              </div>
              {/* <div >
                        <span>{t('common.show-history')}</span>
                     </div> */}
            </div>
            <div>
              {leaveInfo.approvalStatusId === 1 && (
                <p className="text-[#22C55E] font-semibold uppercase">
                  {t("common.approved")}
                </p>
              )}
              {leaveInfo.approvalStatusId === 3 && (
                <p className="text-[#EAB308] font-semibold uppercase">
                  {t("common.requested")}
                </p>
              )}
              {leaveInfo.approvalStatusId === 2 && (
                <p className="text-[#EF4444] font-semibold uppercase">
                  {t("common.rejected")}
                </p>
              )}
            </div>
          </div>
          {(() => {
            const show =
              leaveInfo?.approvalStatusId === 1 ||
              leaveInfo?.approvalStatusId === 3 ||
              leaveInfo?.approvalStatusId === 2;

            if (!show) return null;

            const reason = isAdmin
              ? leaveInfo?.requestReason
              : leaveInfo?.responseReason;

            if (!reason) return null;

            return (
              <div className="flex gap-1">
                <p className="italic">
                  <strong>{t("common.reason")}:</strong> {reason}
                </p>
              </div>
            );
          })()}
          <div className="flex justify-end gap-2">
            {isAdmin && leaveInfo.approvalStatusId === 3 && (
              <ControlpanelPrimaryButton onClick={() => {markNotificationRead(leaveInfo?.leaveId);handleOpenApproveLeave()}}>
                <InfoIcon />
                <p>{t("button.details")}</p>
              </ControlpanelPrimaryButton>
            )}
            {leaveInfo.approvalStatusId === 3 && leaveInfo?.userId == profile.userId && (
              <ControlpanelSuccessButton onClick={handleOpenEditLeave}>
                <PencilEditIcon16pxSvg />
                <p>{t("button.edit")}</p>
              </ControlpanelSuccessButton>
            )}

            {leaveInfo.approvalStatusId === 3 && leaveInfo?.userId == profile.userId && (
              <ControlpanelErrorButton onClick={handleOpenDeleteLeave}>
                <CloseIcon />
                <p>{t("button.delete")}</p>
              </ControlpanelErrorButton>
            )}
          </div>


          <div className="flex gap-1 justify-end">
            {isAdmin && leaveInfo.approvalStatusId === 1 && (
              <div className="flex justify-end gap-2">
                <ControlpanelErrorButton onClick={handleOpenDeleteLeave}>
                  <CloseIcon />
                  <p>{t("button.delete")}</p>
                </ControlpanelErrorButton>
              </div>
            )}
            {(leaveInfo.approvalStatusId === 2 ||
              leaveInfo.approvalStatusId === 1) && (
                <div className="flex justify-end gap-2">
                  <ControlpanelPrimaryButton onClick={()=>{markNotificationRead(leaveInfo?.leaveId);handleOpenApproveLeaveAR()}}>
                    <InfoIcon />
                    <p>{t("button.details")}</p>
                  </ControlpanelPrimaryButton>
                </div>
              )}

          </div>
        </div>
      )}
      {tabValue === 1 && Object.keys(holidayInfo).length > 0 && (
        <div className="holidays-info p-3 shadow-primary mt-3 rounded-md flex flex-col gap-3">
          <div className="flex justify-between">
            <div className="flex flex-col gap-1">
              <p className="text-base font-semibold">
                {holidayInfo.description}
              </p>
            </div>
            <div>
              <p className="opacity-70">
                {formatDateString(
                  holidayInfo.startDateEffective,
                  genaralSettingDateFormat || settings.dateFormat
                )}
              </p>
            </div>
          </div>
          {isAdmin && (
            <div className="flex justify-end gap-2">
              <ControlpanelErrorButton onClick={handleOpenDeleteHoliday}>
                <CloseIcon />
                <p>{t("button.delete")}</p>
              </ControlpanelErrorButton>

              <>
                <ControlpanelPrimaryButton
                  onClick={handleOpenEditHoliday}
                  sx={{
                    borderRadius: "8px",
                    textDecoration: "none",
                  }}
                >
                  <PencilEditIcon16pxSvg />
                  <p>{t("button.edit")}</p>
                </ControlpanelPrimaryButton>
              </>
            </div>
          )}
        </div>
      )}
      <div className="p-3 shadow-primary mt-3 rounded-md">
        <LeaveAndHolidaysMonthEventsCalendar
          tabValue={tabValue}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
          setLoading={setLoading}
          refreshData={refreshData}
          calculateDisplayedWeeks={calculateDisplayedWeeks}
          formatLeaveFilter={formatLeaveFilter}
          selectedUser={selectedUser} // ✅ thêm
          selectedGroup={selectedGroup} // ✅ thêm
        />
      </div>
      {renderDialogs()}
    </div>
  );
});

LeaveAndHolidayInfo.displayName = 'LeaveAndHolidayInfo';

export default LeaveAndHolidayInfo;
